<ng-container *transloco="let t">

  <!-- OFFCANVAS Template for Small Screens -->
  <ng-template #offcanvasRef let-offcanvas>
    <div class="offcanvas-header">
      <h4 class="offcanvas-title">{{t("calendar.range.select")}}</h4>
      <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" (click)="onCalendarClose()"></button>
    </div>
    <div class="offcanvas-body">
      <ng-template [ngTemplateOutlet]="calendarSmallScreen" />
    </div>
    <div class="offcanvas-footer">
        <app-button-alt [buttonColor]="'var(--teal-500)'" [textColor]="'white'"
                        [text]="t('calendar.range.close')" [borderColor]="'var(--teal-500)'"
                        (onClickCallback)="onCalendarClose()" [isFullWidth]="true"
                        [isDisabled]="false"></app-button-alt>
    </div>
  </ng-template>

  <!-- DROPDOWN for Large Screens -->
  <ng-container>
    <div ngbDropdown #dropdownRef="ngbDropdown" class="dropdown dropdown--remove-arrow hide-small" (openChange)="dropdownClosed($event)">
      <div class="dropdown" ngbDropdownAnchor>
        <div class="d-flex align-items-center hide-small" [class.large-input]="largeInput" (click)="onOpenDropdown()">
          <ng-template [ngTemplateOutlet]="input"></ng-template>
        </div>
      </div>
      <div ngbDropdownMenu class="dropdown-menu p-0 mt-1">
        <div class="dropdown-holder">
          <div class="calendar-holder">
            <ng-template [ngTemplateOutlet]="calendarBigScreen" />
          </div>
          <button class="btn btn-circle btn-secondary btn-teal btn-sm m-2 float-end"
                  (click)="onApplyClick()"
                  [disabled]="!(pendingMonthRange?.from && pendingMonthRange?.to)">
            <i class="bi bi-search"></i>
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- OFFCANVAS Trigger for Small Screens -->
  <ng-container>
    <div class="d-flex align-items-center hide-large" [class.large-input]="largeInput" (click)="onOpenOffCanvas()">
      <ng-template [ngTemplateOutlet]="input"></ng-template>
    </div>
  </ng-container>

  <ng-template #input>
    <div class="form-floating flex-grow-1 date-wrapper" [ngStyle]="{ width: wrapperWidth || '200px' }">
      <div class="input-group">
        <input id="datepicker"  name="datepicker" [readonly]="true" class="form-control date-input" [value]="getValue()" [placeholder]="t('app.common.date')" />
        <button class="btn btn-outline-secondary bi bi-chevron-down" type="button"></button>
      </div>
    </div>
  </ng-template>

  <ng-template #calendarSmallScreen>
    <app-calendar [isRange]="true" [showSelection]="false" [minDate]="minDate" [maxDate]="maxDate"[alignment]="'vertical'" [fromDate]="fromDate" [toDate]="toDate" (onRangeChange)="onRangeChange($event)" [openDate]="navigationDate" ></app-calendar>
  </ng-template>

  <ng-template #calendarBigScreen>
    <div class="month-picker">
      <app-month-picker-mobile
        [disablePastMonths]="calendarType === EventItemType.UPCOMING"
        [chosenFrom]="{ from: fromDate ?? undefined }"
        [chosenTo]="{ to: toDate ?? undefined }"
        (monthsSelected)="pendingMonthRange = $event">
      </app-month-picker-mobile>
    </div>
  </ng-template>

</ng-container>
